import { Request } from '@/plugins/helper/fetch'
const req = new Request('detail')
export const qrSave = (id, {content, type}) =>{
	return req.patch('save/'+id,{content, type});
}
export default {
	qrSave
}